import React from 'react'
import './modal.scss'
const Modal = ({element}) => {
  return (
 <div
    className='modal'
    >
        <div className='modal__block'>
            {element}
        </div>
    </div>
  )
}

export default Modal